import "./Register.scss";
import { AuthFormWrapper, IRegisterFormValidation, RegisterForm } from "components";
import { useEffect, useState } from "react";
import { useRegisterMutation } from "state/api/authApi";
import { useToastError } from "hooks";

export const Register = () => {

  const [register, { isSuccess, error, isError, isLoading }] = useRegisterMutation();

  const [done, setDone] = useState<boolean>(false);

  useToastError(isError, error, [isLoading]);

  useEffect(() => {
    if (isSuccess) {
      setDone(true);
    }
  }, [isSuccess]);

  const onCompletedFormHandler = (values: IRegisterFormValidation) => {
    register(values);
  };

  if (done) {
    return (
      <div className="general-container-register done">
        <div className="done-container">
          <span>Revise el correo para verificar su usuario</span>
        </div>
      </div>
    );
  }
  return (
    <AuthFormWrapper>
      <RegisterForm onCompletedForm={onCompletedFormHandler} isLoading={isLoading} />
    </AuthFormWrapper>
  );
};